<template>
  <form @submit.prevent="onSubmit">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">{{ `${mode === "create" ? "Create" : "Update"} Vetted Note` }}</p>
      </header>
      <section class="modal-card-body">
        <b-field horizontal label="Status" v-if="mode === 'update'">
          <b-select placeholder="Select a status" v-model="form.status" expanded>
            <option v-for="status in statuses" :value="status" :key="status">
              {{ status }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal label="Short Name">
          <b-input v-model="form.shortText"></b-input>
        </b-field>
        <b-field horizontal label="Long Name">
          <b-input v-model="form.longText"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Cancel</button>
        <button :class="`button is-info ${loading ? 'is-loading' : ''}`">Save</button>
      </footer>
    </div>
  </form>
</template>

<script>
import { VettedStatementService } from "@/services/vettedStatement.service.js";

export default {
  props: {
    mode: {
      type: String,
      default: "create"
    },
    data: {
      type: Object
    },
    organization: {
      type: Object
    }
  },
  data: () => ({
    form: {
      status: "ACTIVE",
      shortText: "",
      longText: ""
    },
    statuses: ["ACTIVE", "ARCHIVED"],
    loading: false
  }),
  mounted() {
    if (this.mode === "update" && this.data) {
      Object.keys(this.form).forEach(key => {
        if (key === "status") {
          this.form[key] = this.data.archived_at ? "ARCHIVED" : "ACTIVE";
        } else {
          this.form[key] = this.data[key] || null;
        }
      });
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;

      const data = {
        ...this.form,
        firm_id: this.organization.id
      };

      if (this.mode === "create") {
        VettedStatementService.create(data).then(
          response => {
            this.$buefy.toast.open({
              message: "Vetted statement has been created",
              type: "is-info",
              position: "is-top-right"
            });
            this.loading = false;
            this.$emit("create-success");
            this.$parent.close();
          },
          err => {
            this.loading = false;
            this.$parent.close(); // closing it for now since it covers the error modal
          }
        );
      } else {
        VettedStatementService.update(this.data.id, data).then(
          response => {
            this.$buefy.toast.open({
              message: "Vetted statement has been updated",
              type: "is-info",
              position: "is-top-right"
            });
            this.loading = false;
            this.$emit("update-success");
            this.$parent.close();
          },
          err => {
            this.loading = false;
            this.$parent.close(); // closing it for now since it covers the error modal
          }
        );
      }
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/partials/modalForm.vue